// extracted by mini-css-extract-plugin
export default {"title":"O2I-Y","description":"_1TZXT","successDescription":"Buc01","details":"pCZwM","skeleton-progress":"hY0BL"};